export function formatScore(score: number): string {
  return score.toFixed(1)
}

function formatDuration(seconds: number): string {
  const s = Math.round(seconds)
  const m = Math.floor(s / 60)
  return `${m}:${String(s % 60).padStart(2, '0')}`
}

export function formatScoreBreakdown(item: {
  score: number
  total_duration_seconds: number
  unique_cars: number
  is_pursuer: boolean
}): string {
  const parts = [
    `балл ${formatScore(item.score)}`,
    `сопровождение ${formatDuration(item.total_duration_seconds)}`,
    `${item.unique_cars} маш.`,
  ]
  if (item.is_pursuer) parts.push('преследователь')
  return parts.join(' · ')
}
